import css from './GSQRCodeModal.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { QRCodeSVG } from 'qrcode.react'

import { IGoodServiceTicketData, Tap2GOTicketTicketStatus } from 'meta/pages/goodsandservices'
import { Dates } from 'utils/dates'

import BalloonBox from 'components/TextBoxes/BalloonBox'
import { useUrlCloudfront } from 'hooks/useEnv'
import DataTestId from 'meta/dataTestId'

type Props = {
  data: IGoodServiceTicketData
}

const GSQRCodeModal: React.FC<Props> = (props) => {
  const { data } = props

  const urlCloudfront = useUrlCloudfront()

  const { t } = useTranslation()

  const isEventEnded = Dates.isAfter(new Date(), new Date(data.validTo_tz))

  const isTicketOutOfTime = data.status == Tap2GOTicketTicketStatus.valid && isEventEnded

  return (
    <div className={css.wrapper}>
      <BalloonBox infoType={'info'} fullWidth noPadding>
        <div className={css.content}>
          <div className={css.title}>{t('goodsAndServices:qr_details_title')}</div>

          <div className={css.qr}>
            <QRCodeSVG
              value={data.secret}
              size={188}
              level="H"
              data-testid={DataTestId.bag.svgQRCodeModal}
              imageSettings={{
                src: `${urlCloudfront}/images/goodsandservices/qr-icon-${data.event.policy.code}.svg`,
                width: 64,
                height: 64,
                excavate: true,
              }}
            />
          </div>

          <div className={css.msgBox}>
            {isTicketOutOfTime && <span>{t('goodsAndServices:status_outOfTime_desc')}</span>}
            {data.status == Tap2GOTicketTicketStatus.checked && (
              <span>{`${t('goodsAndServices:status_checked')} ${Dates.format(new Date(data.dateEntry_tz ?? data.event.datetime_tz), t('goodsAndServices:status_checked_datetime'))}`}</span>
            )}
            {data.status == Tap2GOTicketTicketStatus.cancelled && (
              <span>{t('goodsAndServices:status_cancelled_details')}</span>
            )}
          </div>
        </div>
      </BalloonBox>
    </div>
  )
}

export default GSQRCodeModal
